import { Component } from '@angular/core';
import { NgClass } from '@angular/common';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-state-badge',
  template: `
    <div class="state-badge-container">
      <span class="badge" [ngClass]="badgeClass">
        {{ stateLabel }}
      </span>
    </div>
  `,
  styles: [
    `
      .state-badge-container {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
      }
      .badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 4px 10px;
        border-radius: 12px;
        font-size: 11px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        min-width: 80px;
        text-align: center;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        line-height: 1;
      }
      .badge-available {
        background-color: rgba(46, 125, 50, 0.2);
        color: #81c784;
        border: 1px solid rgba(129, 199, 132, 0.3);
      }
      .badge-disposed {
        background-color: rgba(230, 74, 25, 0.2);
        color: #ff8a65;
        border: 1px solid rgba(255, 138, 101, 0.3);
      }
      .badge-inprogress {
        background-color: rgba(0, 151, 167, 0.2);
        color: #4dd0e1;
        border: 1px solid rgba(77, 208, 225, 0.3);
      }
      .badge-lost {
        background-color: rgba(198, 40, 40, 0.2);
        color: #e57373;
        border: 1px solid rgba(229, 115, 115, 0.3);
      }
      .badge-reserved {
        background-color: rgba(239, 108, 0, 0.2);
        color: #ffb74d;
        border: 1px solid rgba(255, 183, 77, 0.3);
      }
      .badge-storeuse {
        background-color: rgba(106, 27, 154, 0.2);
        color: #ba68c8;
        border: 1px solid rgba(186, 104, 200, 0.3);
      }
    `,
  ],
  standalone: true,
  imports: [NgClass],
})
export class StateBadgeComponent implements ICellRendererAngularComp {
  params!: ICellRendererParams;
  stateLabel = '';
  badgeClass = '';

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.updateState();
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.updateState();
    return true;
  }

  private updateState(): void {
    const state = this.params.value;
    switch (state) {
      case 'A':
        this.stateLabel = 'Available';
        this.badgeClass = 'badge-available';
        break;
      case 'D':
        this.stateLabel = 'Disposed';
        this.badgeClass = 'badge-disposed';
        break;
      case 'I':
        this.stateLabel = 'In Progress';
        this.badgeClass = 'badge-inprogress';
        break;
      case 'L':
        this.stateLabel = 'Lost/Stolen';
        this.badgeClass = 'badge-lost';
        break;
      case 'R':
        this.stateLabel = 'Reserved';
        this.badgeClass = 'badge-reserved';
        break;
      case 'S':
        this.stateLabel = 'Store Use';
        this.badgeClass = 'badge-storeuse';
        break;
      default:
        this.stateLabel = state || 'Unknown';
        this.badgeClass = '';
    }
  }
}
